import { api } from '../config/api'
import { defaultPageSize } from '../utils/constants'
import { generateFilters } from '../utils/filters'

const baseEndpoint = '/KimpleFolderApi'

export const getAllFilteredKimpleFolders = (pageNumber, pageSize = defaultPageSize, filters) => {
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/GetAllFiltered?${params.toString()}`)
}

export const getAllFilteredEphemerides = (pageNumber, pageSize = defaultPageSize, filters) => {
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${baseEndpoint}/GetAllEphemerides?${params.toString()}`)
}

export const getAllByLocaleKimpleFolders = () =>
  api.get(`${baseEndpoint}/getAllByLocale`, { params: { pageNumber: 0, pageSize: 500 } })

export const getRecommendeKimpleFolders = (pageNumber, pageSize = 3) => api.get(`${baseEndpoint}/FeedRecommended`, { params: { pageNumber, pageSize } })

export const getKimpleFolder = (id, locale) => api.get(`${baseEndpoint}/GetByLocale/${id}`, { params: { locale } })

export const getRedirectedKimpleFolder = (folderUrl) => api.get(folderUrl, { ignoreLocale: true })

export const copyKimpleFolder = ({ id, locale }) => api.post(`${baseEndpoint}/${id}/Save`, {}, { params: { id, locale } })

export const getActiveEphemerideKimpleFolders = ({ pageNumber, pageSize = 4, secondPageNumber, secondPageSize = 4 }) =>
  api.get(`${baseEndpoint}/Ephemeride`, { params: { secondPageNumber, pageNumber, secondPageSize, pageSize } })

export const getUsersFromMySchoolsGroup = () => api.get('/AccountApi/GetAllUsersFromSchoolGroup')

export const shareKimpleFolder = ({ folderId, recipients, locale, folderLocale }) =>
  api.post(`${baseEndpoint}/Share`, { folderId, recipients, folderLocale, ignoreLocale: true }, { params: { locale } })

export const getKimpleFolderAssociatedFolders = ({ id, pageNumber = 0, pageSize = defaultPageSize }) =>
  api.get(`${baseEndpoint}/${id}/AssociatedFolders`, { params: { pageNumber, pageSize } })

export const getKimpleFolderAssociatedResources = ({ id, pageNumber = 0, pageSize = defaultPageSize }) =>
  api.get(`${baseEndpoint}/${id}/AssociatedResources`, { params: { pageNumber, pageSize } })

export const getKimpleFolderAssociatedEducationalPrograms = ({ id, pageNumber = 0, pageSize = defaultPageSize }) =>
  api.get(`${baseEndpoint}/${id}/AssociatedEducationalPrograms`, { params: { pageNumber, pageSize } })
